import React from 'react'
import { useEffect, useState } from "react";
import CardSeplag from '../../../../components/CardSeplag'
import RotuloSeplag from '../../../../components/RotuloSeplag'
import { Dropdown } from 'primereact/dropdown'
import { InputMask } from "primereact/inputmask";
import { InputText } from 'primereact/inputtext'
import { Fieldset } from "primereact/fieldset";
import Andamentos from "../andamentos";
import { buscarApuracaoByIndenIndicador, buscarMetaPPA } from "../../../../service/Rag/AvaliacaoPrograma";


export const TabIndicadores = (props) => {
  const [objetivosIndicadores, setObjetivosIndicadores] = useState();
  const [listaIndicadores, setListaIndicadores] = useState();
  const [indicadorSelecionado, setIndicadorSelecionado] = useState(null);

  const [dadosApuracao, setDadosApuracao] = useState(getDadosApuracaoDefault());
  const [dadosMetaPPA, setDadosMetaPPA] = useState();

  useEffect(() =>{
    setListaIndicadores (props.ptaMonitora.ptaFiplan.indicadoresAcao)
  },[]);


  const selectedIndicadorTemplate = (option, props) => {
    if (option) {
      return (
        <div>
          <div>{option.codgIndicador + " - " + option.descIndicador}</div>
        </div>
      );
    }
    return <span>{""}</span>;
  };

  function getDadosApuracaoDefault() {
    return {
      idenApuracaoIndicador: null,
      valorApuradoFormatado: null,
      valrApurado: null,
      dataApuracao: null,
      indicador: { idenIndicador: null },
    };
  }

  async function onChangeIndicador(e) {
    setIndicadorSelecionado(null);
    setDadosMetaPPA(null);
    setIndicadorSelecionado(e.value ? e.value : null);
    setDadosApuracao(getDadosApuracaoDefault());
    buscarDadosApuracao(e.value);
  }

  async function buscarDadosApuracao(indicador) {
    if (indicador && indicador.idenIndicador) {
      await buscarApuracaoByIndenIndicador(indicador.idenIndicador).then((res) => {
        setDadosApuracao({ ...res.data });
      }).catch(() => {
      });
      await buscarMetaPPA(
        props.ptaMonitora.ptaFiplan.programa.objetivos[0].idenObjetivo,
        indicador.idenIndicador,
        props.ptaMonitora.ptaFiplan.programa.idenPrograma
      ).then((resMeta) => {
        setDadosMetaPPA(resMeta.data);
      }).catch(() => {
      });
    }
  }

  const formartNumber = ({ valrMetaIndicadorObjetivo, descUnidadeMedida }) => {
    if (valrMetaIndicadorObjetivo >= 0) {
      if (descUnidadeMedida === "Percentual") {
        return (
          Number(valrMetaIndicadorObjetivo).toLocaleString("pt-BR", {
            style: "decimal",
            minimumFractionDigits: 3,
          }) + "%"
        );
      } else {
        return Number(valrMetaIndicadorObjetivo).toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 3,
        });
      }
    }

    return "Não informado";
  };

  return ( <>
        <CardSeplag>
          <div className='field col-12'>
              <RotuloSeplag nome="Indicador">
                  <Dropdown
                      emptyMessage="Dados não encontrados"
                      itemTemplate={selectedIndicadorTemplate}
                      valueTemplate={selectedIndicadorTemplate}
                      emptyFilterMessage="Opção não encontrada"
                      id="selIndicador"
                      value={indicadorSelecionado}
                      options={listaIndicadores}
                      onChange={(e) => onChangeIndicador(e)}
                      optionLabel="descIndicador"
                      filter
                      showClear
                      filterBy="descIndicador"
                      style={{height:"30px", width:"50%"}}
                  ></Dropdown>
              </RotuloSeplag>
          </div>
          <div className='field col-12' style={{display:"flex",justifyContent: "space-around"}}>
              <div className='col-3'>
                  <RotuloSeplag nome="Código:" >
                  <label>{indicadorSelecionado?.codgIndicador}</label>
                  </RotuloSeplag>
              </div>
              <div className='col-3'>
                  <RotuloSeplag nome="Fonte de Apuração:">
                    <label>{indicadorSelecionado?.descFonteApuracao}</label>
                  </RotuloSeplag>
              </div>
              <div className='col-3'>
                  <RotuloSeplag nome="Período de Apuração:">
                    <label>{indicadorSelecionado?.flagPeriodicidade}</label>
                  </RotuloSeplag>
              </div>
              <div className='col-3'>
                  <RotuloSeplag nome="Unidade de Medida:">
                    {indicadorSelecionado?.unidadeMedida ? indicadorSelecionado?.unidadeMedida?.descUnidadeMedida : ""}
                  </RotuloSeplag>
              </div>
          </div>
          <div className='col-12' style={{display:"flex"}}>
              <div className='col-3'>
                      <RotuloSeplag nome="Base Geográfica:" >
                        <label>{indicadorSelecionado?.flagBaseGeografica}</label>
                      </RotuloSeplag>
              </div>
              <div className='col-9'>
                  <RotuloSeplag nome="Fórmula de cálculo do Indicador:" >
                    <label>{indicadorSelecionado?.descFormulaCalculo}</label>
                  </RotuloSeplag>
              </div>
          </div>
          <Fieldset legend="Apuração do Indicador" className="field col-12">
            <div className="p-fluid grid">
              <div className="field col-4">
                <RotuloSeplag nome="Descrição:">
                  {indicadorSelecionado ? <label>{indicadorSelecionado.codgIndicador + " - " + indicadorSelecionado.descIndicador}</label> : <></>}
                </RotuloSeplag>
              </div>
              <div className="field col-2">
                <RotuloSeplag nome="Previsto Inicial:">
                    <label>
                        <InputText
                            id="valrPrevistoInicial"
                            value={formartNumber({
                              valrMetaIndicadorObjetivo: dadosMetaPPA?.valrMetaIndicadorObjetivo,
                              descUnidadeMedida: indicadorSelecionado?.unidadeMedida?.descUnidadeMedida,
                            })}
                            disabled={true}
                            />
                    </label>
                </RotuloSeplag>
              </div>
              <div className="field col-2">
                <RotuloSeplag nome="Previsto realizado:">
                  <label>
                    <InputText
                      id="valrPrevistoRealizado"
                      value={dadosApuracao && dadosApuracao.valorApuradoFormatado != null
                        ? dadosApuracao.valorApuradoFormatado
                        : "" }
                      disabled={true}
                    />
                  </label>
                </RotuloSeplag>
              </div>
              <div className="field col-2">
                <RotuloSeplag nome="Realizado:">
                  <label>
                    <InputText
                      id="valrApuradoFormatado"
                      value={dadosApuracao && dadosApuracao.valorApuradoFormatado != null
                        ? dadosApuracao.valorApuradoFormatado
                        : ""}
                      disabled={true}
                    />
                  </label>
                </RotuloSeplag>
              </div>
              <div className="field col-2">
                <RotuloSeplag nome="Data da Apuração:">
                  <label>
                    <InputMask
                      mask="99/99/9999"
                      slotChar="__/__/____"
                      placeholder="__/__/____"
                      id="dataApuracao"
                      value={dadosApuracao?.dataApuracao}
                      disabled={true}
                    />
                  </label>
                </RotuloSeplag>
              </div>
            </div>
          </Fieldset>
        </CardSeplag>
        <hr></hr>
        <CardSeplag>
          <Andamentos
                ptaMonitora={props.ptaMonitora}
                setFormPta={() => props.setForm}
                isPodeVisualizar={true}
                isPodeEditar={true}
                setVisible={true}
          ></Andamentos>
        </CardSeplag>
    </>
  )
};

export default TabIndicadores;
